export function drawArcPath(startAngle: number, endAngle: number, radius: number, centerX: number, centerY: number) {
  // 시작점 좌표 계산
  const x1 = centerX + radius * Math.cos((startAngle * Math.PI) / 180);
  const y1 = centerY + radius * Math.sin((startAngle * Math.PI) / 180);

  // 끝점 좌표 계산
  const x2 = centerX + radius * Math.cos((endAngle * Math.PI) / 180);
  const y2 = centerY + radius * Math.sin((endAngle * Math.PI) / 180);

  // 호의 크기 결정
  const largeArcFlag = endAngle - startAngle > 180 ? 1 : 0;

  // SVG 경로 문자열 생성
  return `M ${x1} ${y1} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${x2} ${y2}`;
}
